import Button from "../Button/Button";
import EventsService from "../../services/EventsService";
import ModalComponent from "../Modal/ModalComponent";
import Select from "../Select/Select";
import { useState } from "react";
import { useUserStore } from "../../contexts/userStore";
import Input from "../Input/Input";
import { useTranslation } from "react-i18next";
import { getEventData } from "../../constants/events";

export function DeleteBatchAlarms({ categories, ...props }) {
   const [modalIsOpen, setModalIsOpen] = useState(false);
   const [alarmEventName, setAlarmEventName] = useState(-1);
   const [alarmStatus, setAlarmStatus] = useState(-1);
   const { selectedCondominio } = useUserStore();
   const [password, setPassword] = useState("");
   const { t } = useTranslation();

   const handleConfirm = async (modalType) => {
      if (modalType === "finish") {
         const query = {
            unitId: selectedCondominio,
            password,
         }
         if (alarmEventName && alarmEventName != -1) {
            query.eventName = alarmEventName;
         }
         if (alarmStatus && alarmStatus != -1) {
            query.status = alarmStatus;
         }
         await EventsService.deleteBatchAlarms(query);
         setModalIsOpen(false);
         setPassword("");
      }
   };

   const handleCancel = (modalType) => {
      if (modalType === "finish") {
         setModalIsOpen(false);
         setPassword("");
      }
   };

   function getPendings() {
      return categories
         .reduce((prev, category) => {
            let increase = 0;
            if (alarmStatus === "pending") {
               increase = category.pending;
            } else if (alarmStatus === "finished") {
               increase = category.finished;
            } else {
               increase = category.pending + category.finished;
            }
            return prev + ((!alarmEventName || alarmEventName == -1 || category.name === alarmEventName) ? increase : 0);
         }, 0);
   }

   return (
      <>
         <Button
            className='w-full'
            label={t("common.clear")}
            action="delete"
            type="button"
            onClick={() => setModalIsOpen(true)}
         />
         <ModalComponent
            modalIsOpen={modalIsOpen}
            modalText={t("monitoring.batchAlarmClear", { pendings: getPendings() })}
            handleConfirm={() => handleConfirm("finish")}
            handleCancel={() => handleCancel("finish")}
         >
            <div style={{ display: 'flex', gap: '14px', width: '420px', flexDirection: 'column', marginTop: '20px' }}>
               <Input
                  labelText={t("common.password")}
                  name="password"
                  id="password"
                  placeholder={t("common.passwordPlaceholder")}
                  value={password}
                  type="password"
                  autoComplete="off"
                  onChange={({ target }) => setPassword(target.value)}
                  required
               />
               <Select
                  labelText={t("common.event")}
                  name="eventName"
                  id="eventName"
                  value={alarmEventName}
                  onChange={({ target }) =>
                     setAlarmEventName(target.value)
                  }
                  options={[
                     { value: -1, text: t("common.all") },
                     ...categories.map(category => {
                        const event = getEventData(category.name);
                        return { value: category.name, text: t(event?.name || category.name) }
                     }),
                  ]}
               />
               <Select
                  labelText={t("common.status")}
                  name="alarmStatus"
                  id="alarmStatus"
                  value={alarmStatus}
                  onChange={({ target }) =>
                     setAlarmStatus(target.value)
                  }
                  options={[
                     { value: -1, text: t("common.all") },
                     { value: "pending", text: t("monitoring.pending") },
                     { value: "finished", text: t("monitoring.finished") },
                  ]}
               />
            </div>
         </ModalComponent>
      </>
   );
}